import { render, staticRenderFns } from "./message.vue?vue&type=template&id=1667916e&"
import script from "./message.component.ts?vue&type=script&lang=ts&"
export * from "./message.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports